import { get, post, put } from 'axios'
import resources from '@/store/modules/resources.js'
import { normalizeFakeEmail } from '@/helpers/mailFake'

const unexpectedError = () =>
  resources.state.resources.general.errors.unexpectedError

const throwError = error => {
  window.dispatchEvent(new Event('error', error))

  const { data = {} } = error.response

  if (data.code) {
    const error = new Error(data.message)
    error.code = data.code
    throw error
  }

  const err = new Error(
    (error.response || { data: { message: unexpectedError() } }).data.message
  )

  throw err
}

const responseData = response => response.data

export const alterCard = iuguData =>
  put('subscription/credit-card', {
    iuguCreditCard: {
      id: iuguData.id,
      bin: iuguData.extra_info.bin,
      brand: iuguData.extra_info.brand,
      display_number: iuguData.extra_info.display_number,
      holder_name: iuguData.extra_info.holder_name,
      month: iuguData.extra_info.month,
      year: iuguData.extra_info.year,
    },
  })
    .then(responseData)
    .catch(err => {
      if ((err.response || {}).status === 400) {
        window.dispatchEvent(new Event('error', err))
        err.response.data.message = unexpectedError()
      }
      throwError(err)
    })

export const subscribe = (name, doc, plan, iuguData, address) =>
  post('/subscription', {
    licenses: plan.licenses,
    period: plan.period,
    promotionalCode: plan.promoCode || '',
    planId: plan.id,
    name: name,
    doc: doc,
    iuguCreditCard: {
      id: iuguData.id,
      bin: iuguData.extra_info.bin,
      brand: iuguData.extra_info.brand,
      display_number: iuguData.extra_info.display_number,
      holder_name: iuguData.extra_info.holder_name,
      month: iuguData.extra_info.month,
      year: iuguData.extra_info.year,
    },
    address,
  })
    .then(responseData)
    .catch(err => {
      if ((err.response || {}).status === 400) {
        window.dispatchEvent(new Event('error', err))
        err.response.data.message = unexpectedError()
      }
      throwError(err)
    })

export const currentUpgradeInfo = () =>
  get('/subscription/upgrade-simulation')
    .then(responseData)
    .catch(throwError)

export const getAccountInfo = () => get('/company/account')

export const updateModulesSettings = settings =>
  put('/company/account/settings', { settings })

export const getPlans = () => get('/plans')

export const updateBoletoLicenses = ({ licenses }) =>
  put('/subscription/licenses', { licenses })
    .then(responseData)
    .catch(throwError)

export const updateSubscription = ({ licenses, period }) =>
  put('/subscription', { licenses, period })
    .then(responseData)
    .catch(throwError)

export const register = data =>
  post('/users', data)
    .then(responseData)
    .catch(err => {
      throwError(
        Object.assign(
          {
            response: { data: { message: 'REGISTER_ERROR' } },
          },
          err
        )
      )
    })

export const login = data =>
  post('/auth/login', { ...data, email: normalizeFakeEmail(data.email.trim()) })
    .then(responseData)
    .catch(throwError)

export const loginWithToken = token =>
  post('/auth/login-token', { token })
    .then(responseData)
    .catch(throwError)

export const sendPassword = (email, secretQuestion, secretQuestionAnswer) =>
  post('/reset-password', {
    email: normalizeFakeEmail(email.trim()),
    secretQuestion,
    secretQuestionAnswer,
  })
    .then(responseData)
    .catch(throwError)

export const resetPassword = data =>
  post('/reset-password', data)
    .then(responseData)
    .catch(throwError)

export const getConfirmURL = () =>
  get('/accounts/token')
    .then(responseData)
    .catch(throwError)

export default {
  currentUpgradeInfo,
  subscribe,
  getAccountInfo,
  updateModulesSettings,
  getPlans,
  updateBoletoLicenses,
  alterCard,
  getConfirmURL,
}
